<template>
  <div class="set-suborder-state-container">
    <h4>
      {{ $t('suborderstatus') }}:
      <v-chip
        v-if="currentStatus.name"
        :color="currentStatus.color"
        :style="{
          color: currentStatus.dark ? '#fff' : '#000'
        }"
      >
        {{ $tc(currentStatus.dad.name, 1) }} - {{ $t(currentStatus.name) }}
      </v-chip>
    </h4>
    <div class="container-buttons">
      <v-btn
        v-for="item in filteredStates"
        :key="item.pk"
        :color="item.color"
        :style="{
          color: item.dark ? '#fff' : '#000'
        }"
        @click="setOrderStatus(item.pk, item.name, item)"
      >
        {{ $t(item.name) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    states: {
      type: Array,
      default: () => [],
      required: true
    },
    value: Number
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    }),
    /**
     * Computado que busca el nombre del estado actual de la suborden
     *
     * @returns {String} Nombre del estado
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    currentStatus() {
      const result = {
        name: '',
        color: '',
        dark: false,
        position: 0,
        dad: {
          name: ''
        }
      }
      const found = this.states.find((element) => element.pk === this.value)
      if (found) {
        result.name = found.name
        result.color = found.color
        result.dark = found.dark
        result.position = found.position
        result.dad.name = found.dad.name
      }
      return result
    },
    /**
     * Computado que filtra los subestados según los siguientes criterios:
     * - No se deben mostrar los in_wait de ningún de ninguna etapa
     * - Tampoco los subestados que tengan una posición menor a la actual.
     *
     * @returns {Array}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    filteredStates() {
      const result = this.states.filter(
        (item) =>
          item.name !== 'in_wait' && item.position > this.currentStatus.position
      )
      return this.filterByStage(result, this.currentStatus.dad.name)
    }
  },
  methods: {
    ...mapActions({
      showConfirmation: 'confirmation/confirmationValue'
    }),
    /**
     * Método para asignar el estado a la suborden, enviar el formulario y
     * cerrar la modal de la suborden.
     *
     * @param {Number} itemPK    ID del estado
     * @param {String} itemName  Nombre del estado
     * @param {object} item Objeto del estado
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    setOrderStatus(itemPK, itemName, item) {
      this.showConfirmation({
        show: true,
        type: 'primary',
        title: this.$tc('change', 2),
        model: this.$t('suborderstatus'),
        content: this.$t('change_status.to', { value: this.$tc(itemName) }),
        alert: `${this.$t('success', {
          model: this.$t('suborderstatus'),
          action: this.$tc('change', 1)
        })}`,
        confirm: () => {
          this.$emit('input', itemPK)
          this.$emit('submitAndClose')
          if (
            itemName === 'rejected' &&
            item.dad.name === 'design_under_review'
          ) {
            this.$emit('confirmDesigner')
          }
        }
      })
    },
    /**
     * Método que filtra los subestados dependiendo del estado en el que esté
     * la suborden.
     * - Diseño: Si la suborden está "en espera", mostrar todos menos
     * "finalizado".
     * - Producción: Si la suborden está "en espera", mostrar todos menos
     * "Lista a entregar".
     *
     * @param {Array} states   Arreglo de subestados que se filtrará
     * @param {String} parent  Nombre del estado padre
     * @returns {Array} Array filtrado de pendiendo de la condicional
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    filterByStage(states, parent) {
      const STATES = {
        design: () => {
          if (this.currentStatus.name === 'in_wait') {
            return states.filter((item) => item.name !== 'finished')
          }
          return states
        },
        production: () => {
          if (this.currentStatus.name === 'in_wait') {
            return states.filter((item) => item.name !== 'ready_to_deliver')
          }
          return states
        },
        default: () => states
      }

      return (STATES[parent] || STATES.default)()
    }
  }
}
</script>
<style lang="sass">
.set-suborder-state-container
  background-color: rgb(0 0 0 / .12)
  padding: 1rem
  margin-bottom: 1rem
  border-radius: 16px
  .container-buttons
    display: flex
    flex-wrap: wrap
    flex-direction: row
    gap: 15px
    margin-bottom: 15px
    margin-top: 20px
</style>
